import React from 'react';
import { Card } from '../SubscriptionAppCard';
interface ReportSectionProps {
  id?: string;
  title: string;
  children: React.ReactNode;
}
export function ReportSection({
  id,
  title,
  children
}: ReportSectionProps) {
  return <section id={id} aria-labelledby={id ? `${id}-title` : undefined} className="scroll-mt-6" data-id="element-3641" data-mp="s99fak4tpmdq">
      <Card padding="none" data-id="element-3642" data-mp="x2au6s515lxb">
        <div className="px-6 py-4 border-b border-[#E2E8F0]" data-id="element-3643" data-mp="x3lwsomqonmu">
          <h2 id={id ? `${id}-title` : undefined} className="text-[16px] font-semibold text-[#0F172A]" data-id="element-3644" data-mp="11zu8tt5n40ps">
            {title}
          </h2>
        </div>
        <div className="p-6" data-id="element-3645" data-mp="1b1aj80wgg2u0">{children}</div>
      </Card>
    </section>;
}